import './ExitFormDetailsAdmin.scss'
import React, { Key, useEffect, useState } from 'react'
import { ExitFormPdf, HorizontalLoader, Pagination } from 'Components'
import { IExitFormDetails } from 'Models'
import { DateConverter, handleError, TableSerialNumber } from 'Helpers'
import employeeService from 'Services/employeeService'
import { pdf } from '@react-pdf/renderer'
import Swal from 'sweetalert2'
import toast from 'react-hot-toast'

// interface ExitDetailsProps {
//   data: IExitFormDetails[]
//   loading: boolean
//   paginationData: {
//     pageNumber: number
//     pageSize: number
//     total: number
//   }
//   setPage: React.Dispatch<React.SetStateAction<number>>
//   pageNumber: number
//   handlePreview: () => void
// }

export const ExitDetailsAdmin = () => {
  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [existDetails, setExitDetails] = useState<IExitFormDetails[]>([])
  const [page, setPage] = useState<number>(1)
  const [exitLoading, setExitLoading] = useState<boolean>(false)
  // console.log('existDetails', existDetails[0].returnOf[0])
  // console.log('existDetails photo', existDetails[0].employee.photo.url)

  const fetchExitDetails = async () => {
    try {
      setExitLoading(true)
      const res = await employeeService.getExitForms(page)
      // console.log('all exit details', res.data.data.dataset)
      const data = res.data.data
      setExitDetails(data.dataset)

      setPaginationData({
        pageNumber: data.pageNumber,
        pageSize: data.pageSize,
        total: data.total,
      })
    } catch (error) {
      handleError(error)
    } finally {
      setExitLoading(false)
    }
  }

  useEffect(() => {
    fetchExitDetails()
  }, [])

  const handleView = async (selectedUser: any) => {
    toast.loading('Preview loading, please wait...')
    try {
      const res = await employeeService.getSingleExitForm(page, selectedUser)
      // console.log('single exit details', res.data.data.dataset)
      const data = res.data.data
      const blob = await pdf(<ExitFormPdf dataset={data.dataset} />).toBlob()
      const url = URL.createObjectURL(blob)
      window.open(url, '_blank')
      toast.dismiss()
      setTimeout(() => {
        URL.revokeObjectURL(url)
      }, 10000)
    } catch (error: any) {
      console.error('PDF preview error:', error)
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          cancelButton: 'btn btn-danger',
        },
        buttonsStyling: false,
      })

      swalWithBootstrapButtons.fire({
        title: 'Oops!',
        text: error.response.data.error,
        icon: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'close',
        reverseButtons: true,
      })
    }
  }

  // console.log('exit comp data', data)

  return (
    <div className='ExitFormDetailsAdmin'>
      <div className='card-body row custom-card'>
        <div className='card px-md-4 border-0 shadow-sm'>
          <div className='card-body'>
            <div className='row card-header'>
              <div className='col-12 col-sm-8'>Completed Off Boarding Users</div>
              {/* <div className='my-auto text-end btn-0 col-12 col-sm-4'>
                <button className='btn btn-default btn-alt' type='button' onClick={handlePreview}>
                  Preview All
                </button>
              </div> */}
            </div>
            <div className='table-wrapper'>
              <table className='table'>
                <thead>
                  <tr className='row-header'>
                    <td className='d-none d-md-table-cell'>S/N</td>
                    <td>Fullname</td>
                    <td className='d-none d-md-table-cell'>Email</td>
                    <td>Role</td>
                    <td>Supervisor</td>
                    <td>Start Date</td>
                    <td>End Date</td>
                    <td>Status</td>
                    <td>Date Exited</td>
                    <td>Action</td>
                  </tr>
                </thead>
                <tbody>
                  {existDetails?.length > 0 &&
                    existDetails?.map((data, index: Key) => (
                      <tr key={index}>
                        <td className='d-none d-md-table-cell'>
                          {TableSerialNumber(
                            page,
                            paginationData.pageSize,
                            parseInt(index.toString()),
                          )}
                        </td>
                        <td className='table-data-cell'>
                          {data.employee.firstName} {data.employee.lastName}
                        </td>
                        <td className='text-truncate overflow-hidden d-none d-md-table-cell'>
                          {data.employee.emailAddress}
                        </td>
                        <td>{data.employee.role}</td>
                        <td>{data.supervisorName}</td>
                        <td className='table-data-cell'>{data.employmentStartDate}</td>
                        <td className='table-data-cell'>{data.employmentEndDate}</td>
                        <td>
                          {['ACTIVE', 'ON_OFFBOARDING', 'COMPLETED_OFFBOARDING'].includes(
                            data.employee.employmentStatus,
                          ) ? (
                            <span className='status'>active</span>
                          ) : ['TERMINATED'].includes(data.employee.employmentStatus) ? (
                            <span className='in-active'>inactive</span>
                          ) : (
                            <span className='status'>
                              {data.employee.employmentStatus.toLowerCase()}
                            </span>
                          )}
                        </td>
                        <td className='table-data-cell'>{DateConverter(data.createdAt)}</td>
                        <td
                          className='btn badge view'
                          onClick={() => {
                            handleView(data.userId)
                          }}
                        >
                          View
                        </td>
                      </tr>
                    ))}
                  {exitLoading === false && existDetails.length === 0 && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        No exit forms found
                      </td>
                    </tr>
                  )}
                  {exitLoading === true && (
                    <tr>
                      <td colSpan={8} className='text-center'>
                        <HorizontalLoader></HorizontalLoader>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {paginationData.total >= paginationData.pageSize && (
            <div className='pagination w-100 d-flex justify-content-center'>
              {paginationData.total && (
                <Pagination
                  className='pagination-bar ps-0'
                  currentPage={Number(paginationData.pageNumber)}
                  totalCount={paginationData.total}
                  pageSize={paginationData.pageSize}
                  onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
